var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgQa = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qa_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 5a11 11 0 1 0 11 11A11.021 11.021 0 0 0 16 5Zm0 17.77a1.269 1.269 0 1 1 0-2.538 1.269 1.269 0 0 1 0 2.537Zm.846-5.173v.095a.846.846 0 0 1-1.692 0v-.846A.846.846 0 0 1 16 16a2.115 2.115 0 1 0-2.115-2.115.846.846 0 1 1-1.693 0 3.807 3.807 0 1 1 4.654 3.712Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qa_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h32v32H0z"
  })))));
});
SvgQa.displayName = "SvgQa";
export default SvgQa;